import { jwtService } from '../common/service/jwt-service'
import { accessTokenService } from '../common/service/token/access-token-service'
import { authDao } from '../dao/auth-dao'

export const authService = {
  deactivateOwnAccount: async (): Promise<void> => {
    return authDao.deactivateOwnAccount()
  },
  hasUserAcceptedLegalAgreements: (): boolean => {
    try {
      const accessToken = accessTokenService.get()
      const jwtPayload = jwtService.decode(accessToken)
      return jwtPayload.meta.legalAgreementVerified
    } catch (err) {
      return false
    }
  },
}
